import "./ComplaintItemDisplayFragment.scss";
import type { complaintAttachmentDisplayVM } from "./complaintAttachmentDisplayVM";

export default function ComplaintAttachmentDisplayFragment(props: {
  items: complaintAttachmentDisplayVM[];
}) {
  return (
    <>
      <ol>
        {props.items.map((item) => (
          <li key={item.id}>
            <a
              href={"/api/Complaints/AttachmentDownload/Open/" + item.id}
              target="_blank"
              title="Otwórz plik"
            >
              {item.attachmentName}
            </a>
            &nbsp;
            <a
              href={"/api/Complaints/AttachmentDownload/Download/" + item.id}
              title="Pobierz plik"
            >
              <i className="bi bi-file-earmark-arrow-down-fill"></i>
            </a>
          </li>
        ))}
      </ol>
    </>
  );
}
